<template>
	<TnInputFile v-bind="model"></TnInputFile>
</template>

<script>
export default defineNuxtComponent({
	name: "Input_file",
	props: ["component"],

	computed: {
		model() {
			const content = this.component && this.component.content;

			if (!content) return;

			return {
				name: content.name,
				label: content.label,
				types: content.accept && content.accept.map((type) => "." + type.toLowerCase()),
				required: content.isMandatory || false,
				error: this.component && this.component.error,
				multiple: true,
			};
		},
	},
});
</script>
